export type DeviceType =
  | "extraLarge"
  | "large"
  | "medium"
  | "tablet"
  | "largeMobile"
  | "mobile"
  | "smallMobile";

/**
 * Maximum widths in px for a screen
 * to be considered each type of
 * device.
 */
export const deviceBreakpoints: Record<DeviceType, number> = {
  extraLarge: 1800,
  large: 1440,
  medium: 1024,
  tablet: 768,
  largeMobile: 425,
  mobile: 375,
  smallMobile: 320,
};
